import { render, staticRenderFns } from "./FilasTarefasPage.vue?vue&type=template&id=09c9cc2a"
import script from "./FilasTarefasPage.vue?vue&type=script&lang=js"
export * from "./FilasTarefasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports